import { useState } from "react";
import { post } from "../networking/RequestService";
import moment from "moment";
import { isNumber } from "lodash";

const useEditDeal = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const editDeal = async (dealData) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "olanakGuncelle",
                id: dealData.id,
                profil: dealData.profilId,
                ad: dealData.ad,
                accountName: dealData.accountName,
                amount: dealData.amount,
                units: dealData.units,
                etiketId: dealData.etiketId,
                kapanmaTarihi: dealData.kapanmaTarihi
                    ? isNumber(dealData.kapanmaTarihi)
                        ? dealData.kapanmaTarihi
                        : moment(dealData.kapanmaTarihi, "YYYY-MM-DD").valueOf()
                    : dealData.closingDate
                    ? dealData.closingDate
                    : null,
                type: dealData.type,
                paid: dealData.paid,
                certificateName: dealData.certificateName || "",
                certificateLastName: dealData.certificateLastName || "",
                nationalIdNumber: dealData.nationalIdNumber || "",
                membership: dealData.membership || "",
                typeChannel: dealData.typeChannel || dealData.channelType,
                durum: dealData.status || dealData.durum,
                lastStatus: dealData.lastStatus,
                // The backend keeps the stored type when this equals it, and accepts a different one only
                // from the deal's switch group - the same list getDealById returns as dealCampaignTypeOptions.
                dealCampaignType: dealData.dealCampaignType,
                isSelfInvestment:
                    dealData.isSelfInvestment === "Yes" || parseInt(dealData.isSelfInvestment) === 1 ? 1 : 0,
                courseName: dealData.newCourseName
                    ? dealData?.newCourseName
                    : dealData?.courseName?.value || dealData?.courseName, //string
                newCourseNameForInhouse: dealData.newCourseName ? 1 : 0,
                activityId: dealData.activityId,
                unitId: dealData.unitId,
                partnerUserId: dealData.partnerUserId || dealData.partner,
                vatIncludes: dealData.vatIncludes === "Yes" || parseInt(dealData.vatIncludes) === 1 ? 1 : 0,
                paidAmount: dealData.paidAmount,
                vendorPaymentAmount: dealData.vendorPaymentAmount || "",
                leoronMarginAmount: dealData.leoronMarginAmount || "",
                endUser: dealData.endUser || "",
                dateOfBirth: dealData.dateOfBirth
                    ? isNumber(dealData.dateOfBirth)
                        ? dealData.dateOfBirth
                        : moment(dealData.dateOfBirth)
                              .startOf("day")
                              .valueOf()
                    : "",
                physicalAddress: dealData.physicalAddress || "",
                numberOfInstallments: dealData.numberOfInstallments || "",
                // CIPD CV: olanakGuncelle writes deal.cv_attachment_id from this field (see
                // getDealCipdInfoParam on the backend) - without it, editing a deal never
                // attaches a newly-uploaded CV, and never clears one that was deleted either.
                cvAttachmentId:
                    dealData.cvAttachmentId ||
                    dealData.cvAttachment?.id ||
                    dealData.cvAttachment?.attachmentId ||
                    dealData.cvAttachment?.fileId ||
                    null,
            };

            const response = await post(payload);
            //toast.success("Deal updated successfully");
            return response;
        } catch (err) {
            setError(err.response.data.text || err);
            throw err.response.data.text || err;
        } finally {
            setLoading(false);
        }
    };

    return { editDeal, loading, error };
};

export default useEditDeal;
